import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const statCompanyStorageLocaleModule: LocaleModule = {
  name: "statCompanyStorage",
  messages: { en: en, it: it },
};
